const defaultOption = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
            shadowStyle: {
                color: 'rgba(108, 74, 255, 0.15)'
            }
        },
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderWidth: '0',
        textStyle: {
            color: 'rgba(255, 255, 255, 0.85)',
        },
        shadowColor: 'rgba(0, 0, 0, 0.4)',
    },
    xAxis: {
        type: 'category',
        axisLine: {
            lineStyle: {
                color: 'gray',
                opacity: 0.5,
            },
        },
        axisLabel: {
            textStyle: {
                color: '#99989D',
            },
        },
    },
    yAxis: {
        type: 'value',
        axisLabel: {
            textStyle: {
                color: '#99989D',
            },
        },
        splitLine: {
            lineStyle: {
                color: ['gray'],
                opacity: 0.2,
            },
        }
    },
    dataset: {
        dimensions: ['xlabel', 'total', 'near',],
        source: [],
    },
    legend: {
        itemHeight: 12,
        itemWidth: 12,
        icon: 'rect',
        right: 12,
        textStyle: { color: '#99989D', fontSize: '14px' }
    },
    grid: {
        left: 0,
        right: 0,
        bottom: 0,
        containLabel: true,
    },
    series: [
        {
            type: 'bar',
            name: 'Total',
            barMaxWidth: 37,
            // color: {
            //     type: 'linear',
            //     colorStops: [
            //         {
            //             offset: 0,
            //             color: '#748bff',
            //         },
            //         {
            //             offset: 1,
            //             color: '#4d40ff',
            //         },
            //     ],
            // },
            itemStyle: {
                color: 'rgba(108, 74, 255, 1)',
            },
        },
        {
            type: 'bar',
            name: 'Near Term',
            barMaxWidth: 37,
            // color: {
            //     type: 'linear',
            //     colorStops: [
            //         {
            //             offset: 0,
            //             color: '#ffa053',
            //         },
            //         {
            //             offset: 1,
            //             color: '#f77f40',
            //         },
            //     ],
            // },
            itemStyle: {
                color: 'rgba(197, 171, 153, 1)',
            }
        },
    ],
};

export default defaultOption;